import { makeStyles, Box, Grid } from "@material-ui/core";
import { size, DsText } from "@mvp/design-system";
import React from "react";
import { useAppStore } from "../../../hooks";
import { PhoneNumber } from "../../PhoneNumber";
import { modalText } from "./modalText";

const useStyles = makeStyles((theme) => ({
  modalPhoneWrapper: {
    marginTop: "1.5rem",
    display: "flex",
    flexWrap: "wrap",
  },
  modalPhone: {
    color: "#BE143C",
    marginLeft: size.xxxs(theme),
    marginRight: size.xxxs(theme),
  },
  planNameSpacing: {
    paddingLeft: size.xxxs(theme),
    fontWeight: 600,
  },
}));

interface ContinueToGetMessagePassageProps {
  showEnding?: boolean;
}

export const ContinueToGetMessagePassage: React.FC<ContinueToGetMessagePassageProps> = ({ showEnding = true }) => {
  const classes = useStyles();
  const {
    appStore: { planInfo },
  } = useAppStore();
  return (
    <Box className={classes.modalPhoneWrapper}>
      <DsText
        variant="body1"
        text={modalText.continue.beginning}
      ></DsText>
      <Grid className={classes.modalPhone}>
        <PhoneNumber
          color="primary"
          variant="body1"
          text="1-800-TALK-MVP"
          phoneNumber='1-800-825-5687'
        />
      </Grid>
      <DsText variant="body1" text={`${modalText.continue.ending}${showEnding ? '' : '.'}`} />
      { showEnding && <>
        <DsText
          variant="body1"
          className={classes.planNameSpacing}
          text={`in ${planInfo?.planName}.`}
        />
      </>}
      
    </Box>
  );
};
